import React from 'react'
import TimeAgo from 'react-timeago'
import { DateTime } from 'luxon'

function CartExpiration({ expiresAt, fromGpp = false, onClick }) {
  if (typeof expiresAt === 'string') {
    expiresAt = new Date(expiresAt).getTime()
  }

  const formatter = (_val, _unit, _suffix, date, _nextFormatter, now) => {
    const dateTimeNow = DateTime.fromMillis(now()).setZone('America/Chicago')
    const dateTimeFromNow = DateTime.fromMillis(date).setZone('America/Chicago')
    const difference = dateTimeFromNow.diff(dateTimeNow)

    if (difference <= 0) {
      if (fromGpp) {
        return (
          <>
            <p role="alert">
              <strong>
                Your timer has run out and your tickets are no longer being held
                for you.
              </strong>{' '}
              Would you like to attempt to reload your itinerary?
            </p>
            <button
              className="gpp-cart-sidebar-button button"
              onClick={() => onClick()}
            >
              reload my itinerary
            </button>
          </>
        )
      } else {
        return (
          <span role="alert">
            Your cart has expired, please refresh the page.
          </span>
        )
      }
    }

    const rawMinutes = difference.milliseconds / 60000
    const minutes = Math.floor(rawMinutes)
    const seconds = Math.round((rawMinutes - minutes) * 60)

    if (fromGpp) {
      return (
        <p id="cart-timer">
          We are holding your tickets for you. You have{' '}
          <span
            className="font-bold"
            role="timer"
          >
            {`${minutes < 10 ? '0' : ''}${minutes}:${
              seconds < 10 ? '0' : ''
            }${seconds}`}
          </span>
          <span className="sr-only">minutes</span> to complete your
          transaction and guarantee this itinerary.

          <span
            role="alert"
            key={minutes}
            className="sr-only"
            aria-describedby="cart-timer"
          >
            We are holding your tickets for you. You have {minutes + 1} minutes
            to complete your transaction and guarantee this itinerary.
          </span>
        </p>
      )
    } else {
      return (
        <React.Fragment>
          <span id="cart-timer">
            Your cart will expire in{' '}
            <span
              className="font-bold"
              role="timer"
            >
              {`${minutes < 10 ? '0' : ''}${minutes}:${
                seconds < 10 ? '0' : ''
              }${seconds}`}
            </span>
            <span className="sr-only">minutes</span>. To extend this time,
            refresh the page.
          </span>

          <span
            role="alert"
            key={minutes}
            className="sr-only"
            aria-describedby="cart-timer"
          >
            Your cart will expire in {minutes + 1} minutes. To extend this time,
            refresh the page.
          </span>
        </React.Fragment>
      )
    }
  }

  if (expiresAt) {
    return (
      <section className="bg-white md:shadow md:p-24 mb-10">
        <h3 className="sr-only">Time remaining to complete order</h3>
        <TimeAgo
          date={expiresAt}
          formatter={formatter}
          maxPeriod={1}
        />
      </section>
    )
  } else {
    return null
  }
}

export default CartExpiration
